module.exports = __webpack_public_path__ + "static/herald-of-hadar-mtg_afr-b58e2850d37603917ffe8aad0f3f4744.jpg";